(() => {
  function initMobileMenu(scope = document) {
    const menu = scope.querySelector('[data-mobile-fullscreen-menu]') || document.querySelector('[data-mobile-fullscreen-menu]');
    const button = scope.querySelector('[data-mobile-menu-toggle]') || document.querySelector('[data-mobile-menu-toggle]');

    if (!menu || !button || menu.dataset.initialized) return;
    menu.dataset.initialized = 'true';
    let savedScrollY = 0;

    const closeMenu = () => {
      menu.classList.remove('is-open');
      menu.setAttribute('aria-hidden', 'true');
      button.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('mobile-fullscreen-menu-open');
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      window.scrollTo(0, savedScrollY);
      button.focus({ preventScroll: true });
    };

    const openMenu = () => {
      savedScrollY = window.scrollY;
      document.body.classList.add('mobile-fullscreen-menu-open');
      document.body.style.position = 'fixed';
      document.body.style.top = `-${savedScrollY}px`;
      document.body.style.width = '100%';

      const header = document.querySelector('.site-header');
      if (header) {
        document.documentElement.style.setProperty('--mobile-header-height', `${header.offsetHeight}px`);
      }

      menu.classList.add('is-open');
      menu.setAttribute('aria-hidden', 'false');
      button.setAttribute('aria-expanded', 'true');
    };

    button.addEventListener('click', () => {
      if (menu.classList.contains('is-open')) closeMenu();
      else openMenu();
    });

    menu.addEventListener('click', (event) => {
      const summary = event.target.closest('.mobile-fullscreen-menu__summary');

      if (summary) {
        event.preventDefault();
        const details = summary.parentElement;
        details.open = !details.open;
        return;
      }

      if (event.target.closest('a')) closeMenu();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && menu.classList.contains('is-open')) closeMenu();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initMobileMenu());
  } else {
    initMobileMenu();
  }

  document.addEventListener('shopify:section:load', (event) => initMobileMenu(event.target));
})();
